import TreeItem from './TreeItem'
import Draggable from 'vuedraggable'
import TextareaAutosize from './../../../zzl-vue-component/TextareaAutosize'

const TreeEditor = {
	name: 'TreeEditor',
	props: {
		value: {
			type: Object,
		},
		root: {
			type: Boolean,
			default: true
		},
		depth: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			children: this.value.children.map(TreeItem.wrap)
		}
	},
	components: {
		TextareaAutosize,
		Draggable
	},
	template: `
		<Draggable class="tree-editor-container"
			v-model="children"
			draggable=".tree-editor-item-sort"
			handle=".tree-editor-handle"
			chosen-class="formedit-item-chosen"
			ghost-class="formedit-item-ghost"
			:animation="250"
		>
			<div v-for="(item, index) in children" :key="item.jsid"
				class="tree-editor-item-sort"
			>
				<div class="tree-editor-item-line">
					<span class="tree-editor-handle" title="ドラッグで移動">
						<span class="glyphicon glyphicon-move" aria-label="ドラッグで移動"></span>
					</span>
					<span class="tree-editor-item-name">
						<TextareaAutosize type="text" v-model="children[index].name"
							class="tree-editor-input"
							@input="notifyChange"
						/>
					</span>
					<span class="tree-editor-remove-btn" title="削除" @click="removeItem(index)">
						<span class="glyphicon glyphicon-remove" aria-label="削除"></span>
					</span>
				</div>
				<div v-if="depth > 1" class="tree-editor-children">
					<TreeEditor
						v-model="children[index]"
						:root="false"
						:depth="depth - 1"
					/>
				</div>
			</div>
			<button type="button" class="tree-editor-add-btn"
				v-if="depth > 0"
				@click="insertItem(children.length)"
			>
				<span class="glyphicon glyphicon-plus"></span>
				項目を追加
			</button>
		</Draggable>
	`,
	mounted() {
	},
	methods: {
		insertItem (index) {
			const { children } = this
			if (index < 0 || index > children.length) return
			children.splice(index, 0, TreeItem.wrap({ name: '' }))
		},
		removeItem (index) {
			const { children } = this
			if (index < 0 || index > children.length) return
			children.splice(index, 1)
		},
		notifyChange () {
			const { value } = this
			this.$emit('input', {
				id: value.id || null,
				name: value.name || null,
				enabled: value.enabled || true,
				children: this.children.map(TreeItem.unwrap)
			})
		}
	},
	watch: {
		children () {
			this.notifyChange()
		}
	}
}

TreeEditor.components.TreeEditor = TreeEditor

export default TreeEditor
